module.exports = __webpack_public_path__ + "static/crime-stats-mac-8df727d37320c2fdcb534f1d65811b39.png";